import { render, staticRenderFns } from "./SBSAwardEndorse.vue?vue&type=template&id=c442564c&v-if=isLoggedIn&"
import script from "./SBSAwardEndorse.vue?vue&type=script&lang=js&"
export * from "./SBSAwardEndorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports